// extracted by mini-css-extract-plugin
module.exports = {"root":"root__3bpb0","title":"title__698Hf","items":"items__3DgjV","item":"item__32pjr","itemTitle":"itemTitle__2u0FN","itemDescription":"itemDescription__3gV1-"};